import React,{useState} from 'react';
import {Link} from 'react-router-dom';


import classes from './EachProduct.module.css';

import Card from 'react-bootstrap/Card';
import 'bootstrap/dist/css/bootstrap.min.css';
import Spinner from 'react-bootstrap/Spinner';

function EachProduct(props){
    const [item, setItem]=useState(props.item);
    

  
    let newLink= null;
    
    function correctPath(){
        if (props.path =="/adminedit/rifatnrakib"){
            newLink="/adminedit/rifatnrakib/desc/?perfume="+props.id;
                
        }
        else{
            newLink="/desc/?perfume="+props.id;
         
        }

    }

    return(
        <div className={classes.box} >
            {newLink? null: correctPath()}
            
           <a onClick={()=>props.getProduct(item)} className={classes.item} href={newLink}>
               <Card className={classes.card}>
                <Card.Img className={classes.cardImg} variant="top" src={props.image}  />
                <Card.Body>
                    <Card.Title><div className={classes.stock}>{props.data.stock ==="available" ? null: "(OUT OF STOCK)"} </div></Card.Title>
                    <Card.Title>{props.name} </Card.Title>
                    <Card.Text>
                        
                        <h6><b>Starts from :</b> {props.data.priceAndBottle[1] ? props.data.priceAndBottle[1].price+" ": props.data.priceAndBottle[0].price}BDT</h6>
                        
                    </Card.Text>
                   
                </Card.Body>
            </Card>
            </a>
      
       
         
      </div>
    )
}


export default EachProduct;   